import axios from 'axios'
import { getUiServicesEndpoint } from './utils'
import { PoStatusResponse } from 'common/types'

export const fetchPoStatusByFilters = async (po: string) => {
  const { key, url } = await getUiServicesEndpoint()
  const endpoint = `${url}/v1/purchase_order/${encodeURIComponent(po)}/processing_status?key=${key}`

  return axios.get<PoStatusResponse>(endpoint)
}
